// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    agentsImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770563915/Generator_featured%20images/webflow-sean/hp-ai-slider-agents.avif",
        alt: ""
    },
    agentsLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696ff383d48d51a111c5df1b_agents-oneliner.png",
        alt: ""
    },
    agentsTitle: "Unlimited workforce that amplifies your team’s impact",
    aiProductsImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770299376/Generator_featured%20images/webflow-sean/hp-ai-slider-products.svg",
        alt: ""
    },
    aiProductsLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69849f8fba9553c89f07cebc_monday-ai-products-logo.svg",
        alt: ""
    },
    aiProductsTitle: "Solve any core work challenge with AI-powered products",
    buttonText: "Get Started",
    headingBlack1: "Get ",
    headingBlack1Visibility: true,
    headingBlack2: "with AI that’s woven into your work",
    headingBlack2Visibility: true,
    headingGradient: "more work done ",
    hideComponent: true,
    sidekickImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770280449/Generator_featured%20images/webflow-sean/hp-ai-slider-sidekick.avif",
        alt: ""
    },
    sidekickLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696ff38363e77c85e7a40d31_sidekick-oneliner.png",
        alt: ""
    },
    sidekickTitle: "Move work forward with a built-in personal AI assistant",
    vibeImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770281973/Generator_featured%20images/webflow-sean/hp-ai-slider-vibe.avif",
        alt: ""
    },
    vibeLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696ff38371f2e4f6ef660882_vibe-oneliner.png",
        alt: ""
    },
    vibeTitle: "Build any business software in minutes",
    workflowsImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770280472/Generator_featured%20images/webflow-sean/hp-ai-slider-workflows.avif",
        alt: ""
    },
    workflowsLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696ff38338425f040531ecb1_workflows-oneliner.png",
        alt: ""
    },
    workflowsTitle: "Autonomous workflows that run work end to end"
};
